export default "__VITE_ASSET__bacc5357__$_?nuxt_component=async__"